<template>
  <v-flex>
    <v-row class="pa-5" :justify="isView?'start':'end'">
      <v-btn
      v-if="!isView"
        @click="downloadAjustment"
        small
        outlined
        class="ml-8 rounded text-capitalize"
        tile
        color="primary"
      >
        <v-icon left> print </v-icon>
        Imprimir
      </v-btn>
      <v-btn
      v-else
        @click="isView=false"
        small
        outlined
        class="ml-8 mb-5 rounded text-capitalize"
        tile
        color="primary"
      >
        <v-icon left> keyboard_backspace </v-icon>
        Volver
      </v-btn>
    </v-row>
    <div v-if="isView">
      <iframe v-if="pdfUrl" style="min-height: 90vh; width: 100%; position: relative" :src="pdfUrl" frameborder="0"
      allowfullscreen></iframe>
    </div>
    <div v-else>
      <v-row justify="center" no-gutters>
      <v-col cols="12" md="12">
        <v-container v-if="data_adjustment != null" fluid>
          <div class="folded_corner mt-0">
            <v-row justify="center">
              <span class="mt-0" style="font-size: 18px; color: #616161"
                >AJUSTE DE INVENTARIO
              </span>
            </v-row>
            <v-row justify="center">
              <span class="mt-0" style="font-size: 18px; color: #616161"
                >{{ data_adjustment[0].business_unit_description }} ({{ data_adjustment[0].location_description }})
              </span>
            </v-row>
            <v-row justify="center" class="mt-14">
              <v-col cols="12" md="1"> </v-col>
              <v-col cols="12" md="5">
                <span class="ml">Almacen</span>
                <span style="text-decoration: underline" class="mx-4 font-weight-bold">{{
                  data_adjustment[0].warehouse_name
                }}</span>
              </v-col>
              <v-col cols="12" md="5">
                <v-row justify="end">
                  <span class="mr-3 float-right"
                    >Fecha
                    <b>{{ getDate(data_adjustment[0].effective_date,'d') }}</b>
                  </span>
                </v-row>
              </v-col>
              <v-col cols="12" md="1"> </v-col>
            </v-row>
            <v-row justify="center" class="mt-0">
              <v-col cols="12" md="1"> </v-col>
              <v-col cols="12" md="5">
                <span class="ml">Registrado por</span>
                <span style="text-decoration: underline" class="mx-4 font-weight-bold">{{
                 data_adjustment[0].created_at
                }}</span>
              </v-col>
              <v-col cols="12" md="5">
                <v-row justify="end">
                  <span class="mr-3 float-right"
                    >Hora
                    <b>{{ getDate(data_adjustment[0].effective_date,'h') }}</b>
                  </span>
                </v-row>
              </v-col>
              <v-col cols="12" md="1"> </v-col>
            </v-row>

            <v-row justify="center" class="mt-10">
              <v-col cols="10">
                <v-data-table
                  :headers="headers"
                  :items="data_adjustment"
                  dense
                  hide-default-footer
                  :items-per-page="1005"
                  class="elevation-0"
                >
                 <template v-slot:item.index="{ index }">
                        {{ index + 1 }}
                      </template>
                        <template v-slot:[`item.quantity_difference`]="{ item }">
                        <span> <v-icon :color="parseFloat(item.quantity_difference) >= 0 ? 'success' : 'error'" small>{{ parseFloat(item.quantity_difference) >= 0 ? 'mdi-plus' : 'mdi-minus' }}</v-icon>  {{ Math.abs(parseFloat(item.quantity_difference)) }} </span>
                      </template>
                  <template v-slot:footer> </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row justify="center" class="mt-10 mb-10">
              <span class="">Nota : </span>
              <span class="mx-4 font-weight-normal">
                {{ data_adjustment[0].note }}
              </span>
            </v-row>
            <v-row class="mb-3"> </v-row>
          </div>

          <v-container>
            <h3 class="text-center">Contabilidad</h3>

            <v-data-table
              :headers="headersContabilidad"
              :items="accounting"
              class="elevation-0 rounded-lg mt4 mb-4"
              hide-default-footer
              :items-per-page="100"
              style=""
            >
              <template v-slot:[`item.chart_of_account_name`]="{ item }">
                <span class="primary--text">
                  {{ item.chart_of_account_code }}
                </span>
                -
                <span>
                  {{ item.chart_of_account_name }}
                </span>
              </template>

              <template v-slot:[`item.debito`]="{ item }">
                <span v-if="item.entry_type_id == 1">
                  {{ currencyFormat(item.amount) }}
                </span>
              </template>

              <template v-slot:[`item.credito`]="{ item }">
                <span v-if="item.entry_type_id == 2">
                  {{ currencyFormat(item.amount) }}</span
                >
              </template>

              <template slot="body.append">
                <tr class="mt-2 mb-2">
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th class="font-weight-bold" style="color: #616161; font-size: 20px">
                    TOTAL
                  </th>
                  <!-- <th class="title">{{ sumField("calories") }}</th>
                              <th class="title">{{ sumField("fat") }}</th> -->
                  <th
                    style="font-size: 18px"
                    class="font-weight-normal text-right success--text"
                  >
                    {{
                      currencyFormat(
                        accounting.reduce((acc, entry) => {
                          if (entry.entry_type_id === 1) {
                            return acc + parseFloat(entry.amount);
                          } else {
                            return acc;
                          }
                        }, 0)
                      )
                    }}
                    {{ accounting.length ? accounting[0].currency_code : "" }}
                  </th>
                  <th
                    class="font-weight-normal text-right error--text"
                    style="color: #616161; font-size: 18px"
                  >
                    {{
                      currencyFormat(
                        accounting.reduce((acc, entry) => {
                          if (entry.entry_type_id === 2) {
                            return acc + parseFloat(entry.amount);
                          } else {
                            return acc;
                          }
                        }, 0)
                      )
                    }}
                    {{ accounting.length ? accounting[0].currency_code : "" }}
                  </th>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-container>
      </v-col>
    </v-row>
    </div>
   
  </v-flex>
</template>

<script>
import moment from "moment";

export default {
  data: () => ({
    accounting: [],
    storage_invoice: "",
    pdfUrl: null,
    headersContabilidad: [
      {
        text: "Asiento",
        align: "start",
        sortable: false,
        value: "diary_book_code",
      },
      { text: "Cuenta", value: "chart_of_account_name" },
      { text: "Location", value: "location_description" },
      { text: "Entidad", value: "entity_name" },
      { text: "Categoria", value: "category_name" },
      { text: "Sub Categoria", value: "subcategory_name" },
      { text: "Debito", value: "debito", align: "right" },
      { text: "Credito", value: "credito", align: "right" },
    ],
    isView:false,
    id_transactions: null,
    data_adjustment: null,
    data_transactions_entity: [],
    selectedAttached: "",
    headers: [
       { text: "#", value: "index",width: "3%" },
      {
        text: "Id",
        align: "start",
        sortable: false,
        value: "item_id",
        width: "5%"
      },
      {
        text: "Articulo",
        value: "name",
      },
      {
        text: "Cantidad anterior",
        value: "old_quantity",
         align: "end",
      },
      // {
      //   text: "Cantidad nueva",
      //   value: "new_quantity",
      // },
      {
        text: "Cantidad ajustada",
        value: "quantity_difference",
        align: "end",
      },
    ],
  }),

  created() {
    this.getData();
  },
  methods: {
   async downloadAjustment()
    {
      this.loading = true;
      this.isView=true
       
      // const responseRequest = await this.api_Post("income/search_invoice_id", {
      //   number: invoice_id,
      // });
      // let data_invoice = "";
      // if (responseRequest.status == 200) {
      //   data_invoice = await responseRequest.json();
    
      // } else {
      //   this.$toast.error("error al cargar la factura!");
      // }

      const responseDataPdf = await this.api_Post("inventory/adjustmentsDetail", {
        id: this.$route.params.id,
        send_pdf:true
      });

      const blob = await responseDataPdf.blob();
      const pdfUrl = URL.createObjectURL(blob);

      this.pdfUrl = pdfUrl;

      this.loading = false;
    },
    async getData() {
      this.loading = true;
      const responseRequest = await this.api_Post("inventory/adjustmentsDetail", {
        id: this.$route.params.id,
      });
      if (responseRequest.status == 200) {
        let data = await responseRequest.json();
        this.data_adjustment = data;
      } else {
        this.$toast.error("error al cargar el pago!");
      }
      const responseAccountig = await this.api_Post("accounting/payment_accounting", {
        filters: `  where warehouse_adjustment_id =${this.$route.params.id}`,
      });
      if (responseAccountig.status == 200) {
        this.accounting = await responseAccountig.json();
      }
      this.loading = false;
    },

    getDate(item,type) {
      if(type=='d'){
        return moment(item).format("DD/MM/YYYY");
      }
      return moment(item).format("hh:mm: a");
    },
  },
};
</script>

<style scoped>
.folded-paper:before {
  content: "";
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  position: absolute;
  top: 0;
  right: 0;
  border-width: 0 30px 30px 0;
  border-style: solid;
  border-color: rgb(74, 92, 67) #fff;
  transition: 0.3s;
  border-radius: 0 0 0 4px;
}

.box {
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048),
    0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),
    0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12);
}

.folded_corner {
  position: relative;
  width: 100%;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
  height: auto;
  border-radius: 5px;

  /* background: #58a; */
  background: linear-gradient(to left bottom, transparent 50%, rgba(194, 193, 193, 0.4) 0)
      no-repeat 100% 0 / 2em 2em,
    linear-gradient(-135deg, transparent 1.5em, rgb(255, 255, 255) 0);

  /* -webkit-filter: drop-shadow(20px 30px rgba(0, 0, 0, 0.1)); */
  /* filter: drop-shadow(20px 30px rgba(0, 0, 0, 0.1)); */
}

/* .folded_corner::before {
        content: " ";
        position: absolute;
        top: 2em;
        right: 0;
        background: linear-gradient(
            to left bottom,
            transparent 50%,
            rgba(0, 0, 0, 0.1) 0
          )
          100% 0 no-repeat;
        width: 2em;
        height: 2em;
        transform: rotate(180deg);
      } */
.some-other-style {
  background: blue;
}

.my-header-style {
  color: #6f8fb9 !important;
}

.containerIframe {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
  /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
